import "bootstrap/dist/js/bootstrap.bundle.min";
import ReactDOM from "react-dom/client";
import "react-range-slider-input/dist/style.css";
import { Provider } from "react-redux";
import "select2/dist/js/select2.min.js";
import App from "./App";
import LanguageProvider from "./context/LanguageContext";
import "./i18n/i18n";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </Provider>
);

reportWebVitals();
